import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { tokenInterceptor } from "../../api/authHeaders";
import { backendURL, config, Backend_Urls } from "../../api/endpoints";

const getSystemData = createAsyncThunk(
  "systemManagement/getSystemData",
  async ({}: {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.admin_url}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getUsers = createAsyncThunk(
  "systemManagement/getUsers",
  async ({}: {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.users_url}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const addUser = createAsyncThunk(
  "systemManagement/addUser",
  async (
    { createUserPayload }: { createUserPayload: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.users_url}`,
        createUserPayload,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const addTrainingUser = createAsyncThunk(
  "systemManagement/addTrainingUser",
  async (
    { createUserPayload }: { createUserPayload: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.training_users}`,
        createUserPayload,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const editTrainingUser = createAsyncThunk(
  "systemManagement/editTrainingUser",
  async (
    { editUserPayload }: { editUserPayload: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.put(
        `${backendURL}${Backend_Urls.training_users}`,
        editUserPayload,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const deleteTrainingUser = createAsyncThunk(
  "systemManagement/deleteTrainingUser",
  async (
    { client_user_index, user_id, client_index }: { client_user_index: any, user_id: any, client_index: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.delete(
        `${backendURL}${Backend_Urls.training_users}`,
        {
          data: { client_user_index, user_id, client_index },
          headers: tokenInterceptor().headers
        }
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const editUser = createAsyncThunk(
  "systemManagement/editUser",
  async (
    { editUserPayload }: { editUserPayload: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.update_user_url}`,
        editUserPayload,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const disableUser = createAsyncThunk(
  "systemManagement/disableUser",
  async (
    { client_user_index }: { client_user_index: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.disable_user_url}`,
        { client_user_index },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const enableUser = createAsyncThunk(
  "systemManagement/enableUser",
  async (
    { client_user_index }: { client_user_index: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.enable_user_url}`,
        { client_user_index },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getClients = createAsyncThunk(
  "systemManagement/getClients",
  async ({}: {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.clients_url}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const addClient = createAsyncThunk(
  "systemManagement/addClient",
  async (
    { createClientPayload }: { createClientPayload: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.clients_url}`,
        createClientPayload,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const editClient = createAsyncThunk(
  "systemManagement/editClient",
  async (
    { editClientPayload }: { editClientPayload: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.update_client_url}`,
        editClientPayload,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const disableClient = createAsyncThunk(
  "systemManagement/disableClient",
  async ({ client_index }: { client_index: any }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.disable_client_url}`,
        { client_index },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const enableClient = createAsyncThunk(
  "systemManagement/enableClient",
  async ({ client_index }: { client_index: any }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.enable_client_url}`,
        { client_index },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getRoles = createAsyncThunk(
  "systemManagement/getRoles",
  async ({}: {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.roles_url}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getProducts = createAsyncThunk(
  "systemManagement/getProducts",
  async ({}: {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.products_url}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const addProduct = createAsyncThunk(
  "systemManagement/addProduct",
  async (
    { createProductPayload }: { createProductPayload: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.products_url}`,
        createProductPayload,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const editProduct = createAsyncThunk(
  "systemManagement/editProduct",
  async (
    { editProductPayload }: { editProductPayload: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.update_product_url}`,
        editProductPayload,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const deleteProduct = createAsyncThunk(
  "systemManagement/deleteProduct",
  async ({ product_index }: { product_index: any }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.delete_product_url}`,
        { product_index },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const enableProduct = createAsyncThunk(
  "systemManagement/enableProduct",
  async ({ product_index }: { product_index: any }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.enable_product_url}`,
        { product_index },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getPrograms = createAsyncThunk(
  "systemManagement/getPrograms",
  async ({}: {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.programs_url}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getPlans = createAsyncThunk(
  "systemManagement/getPlans",
  async ({}: {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.plans_url}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getClientPlan = createAsyncThunk(
  "systemManagement/getClientPlan",
  async ({}: {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.client_plan_url}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getClientType = createAsyncThunk(
  "systemManagement/getClientType",
  async ({}: {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.client_type_url}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getAllClientSalesmen = createAsyncThunk(
  "systemManagement/getAllClientSalesmen",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    // The id is interpolated into the path, so a missing one used to request
    // /all_client_salesmen/undefined verbatim. No caller should be able to do
    // that, whatever it forgets to guard.
    if (customer_id === undefined || customer_id === null || customer_id === "") {
      return rejectWithValue("getAllClientSalesmen called without a customer_id");
    }
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.all_client_salesmen}/${customer_id}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const activateSalesRep = createAsyncThunk(
  "systemManagement/activateSalesRep",
  async (
    { activateSalesRepPayload }: { activateSalesRepPayload: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.activate_sales_rep}`,
        activateSalesRepPayload,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const deactivateSalesRep = createAsyncThunk(
  "systemManagement/deactivateSalesRep",
  async (
    { deactivateSalesRepPayload }: { deactivateSalesRepPayload: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.deactivate_sales_rep}`,
        deactivateSalesRepPayload,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const attachProduct = createAsyncThunk(
  "systemManagement/attachProduct",
  async (
    { attachProductPayload }: { attachProductPayload: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.attach_subscription_url}`,
        { ...attachProductPayload },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getAllClientMarketingCost = createAsyncThunk(
  "systemManagement/getAllClientMarketingCost",
  async ({}: {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.marketing_cost}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const updateClientMarketingCost = createAsyncThunk(
  "systemManagement/updateClientMarketingCost",
  async (
    {
      updateClientMarketingCostPayload,
    }: { updateClientMarketingCostPayload: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.marketing_cost}`,
        updateClientMarketingCostPayload,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getClientAdmin = createAsyncThunk(
  "systemManagement/getClientAdmin",
  async ({ client_id }: { client_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.get_client_admin}`,
        { client_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const updateClientAdminNotification = createAsyncThunk(
  "systemManagement/updateClientAdminNotification",
  async (
    {
      notification,
      client_index,
      client_user_index,
    }: {
      notification: number;
      client_index: string;
      client_user_index: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.update_client_admin_notification}`,
        { notification, client_index, client_user_index },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const updateClientNotification = createAsyncThunk(
  "systemManagement/updateClientNotification",
  async (
    { client_id, notification }: { client_id: string; notification: boolean },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.update_client_notification}`,
        { client_id, notification },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getClientUserTitle = createAsyncThunk(
  "systemManagement/getClientUserTitle",
  async ({}: {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.client_user_title}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const sendEmailNotification = createAsyncThunk(
  "systemManagement/sendEmailNotification",
  async (
    { sendEmailNotificationPayload }: { sendEmailNotificationPayload: any },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.email_notification_url}`,
        { ...sendEmailNotificationPayload },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export {
  getSystemData,
  addUser,
  editUser,
  getUsers,
  disableUser,
  enableUser,
  getClients,
  addClient,
  editClient,
  disableClient,
  enableClient,
  getRoles,
  getProducts,
  editProduct,
  deleteProduct,
  enableProduct,
  addProduct,
  getPrograms,
  getPlans,
  getClientPlan,
  getClientType,
  getAllClientSalesmen,
  activateSalesRep,
  deactivateSalesRep,
  attachProduct,
  getAllClientMarketingCost,
  updateClientMarketingCost,
  getClientAdmin,
  updateClientAdminNotification,
  updateClientNotification,
  getClientUserTitle,
  sendEmailNotification,
  addTrainingUser,
  editTrainingUser,
  deleteTrainingUser
};
